import { render, staticRenderFns } from "./editable.vue?vue&type=template&id=379b4148&scoped=true"
import script from "./editable.vue?vue&type=script&lang=ts"
export * from "./editable.vue?vue&type=script&lang=ts"
import style0 from "./editable.vue?vue&type=style&index=0&id=379b4148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379b4148",
  null
  
)

export default component.exports